import React from 'react';
import { FilterProvider } from '@gettactic/components/src/controls/FilterContext/FilterContext';

/**
 * A higher-order component that wraps a component with FilterProvider
 * to provide filter context functionality without explicitly wrapping components.
 *
 * @param Component The component to wrap with FilterProvider
 * @returns A new component wrapped with FilterProvider
 */
export function withFilterProvider<P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> {
  const WithFilterProvider: React.FC<P> = (props) => {
    return (
      <FilterProvider>
        <Component {...props} />
      </FilterProvider>
    );
  };

  // Set display name for better debugging
  const displayName = Component.displayName || Component.name || 'Component';
  WithFilterProvider.displayName = `withFilterProvider(${displayName})`;

  return WithFilterProvider;
} 